import React from 'react';
import styled from 'styled-components';
import { RatClickTracker } from './RatClickTracker';

const StyledDiv = styled.div`
  position: relative;
  float: right;
`;

const StyledInput = styled.input`
  width: 12vw;
  height: 48px;
  cursor: ${(props: { disabled: boolean }) =>
    props.disabled ? 'default' : 'pointer'};
  color: #fff;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  font-size: small;
  text-align: center;
  padding: 17px 0px;
  outline: 0;
  border: 0;
  background: rgb(191, 0, 0);
  box-sizing: border-box;
  background-color: ${(props: { disabled: boolean }) =>
    props.disabled ? '#FFCFCF' : '#bf0000'};
`;

const StyledButton = styled.button`
  display: block;
  border-radius: 4px;
  float: left;
  width: 17%;
  min-width: 17%;
  height: 55px;
  margin-right: 1%;
  margin-left: 1%;
  margin-bottom: 5px;
  border: 0;
  cursor: pointer;
  background-color: ${(props: { disabled: boolean }) =>
    props.disabled ? '#FFCFCF' : '#bf0000'};
`;

const StyledSpan = styled.span`
  font-size: 14px;
  line-height: normal;
  text-align: center;
  color: #ffffff;
`;

interface Props {
  disabled: boolean;
  isWide: boolean;
  onSubmit: Function;
}

export const ChatSubmitButton = (props: Props) => {
  const { disabled, isWide, onSubmit } = props;

  return isWide ? (
    <StyledDiv>
      <StyledInput
        type="button"
        value="送信"
        onClick={(event) => {
          onSubmit(event);
        }}
        disabled={disabled}
      ></StyledInput>
    </StyledDiv>
  ) : (
    <StyledButton
      onClick={(event) => {
        onSubmit(event);
      }}
      disabled={disabled}
    >
      <RatClickTracker componentId={'send_message'}>
        <StyledSpan>送信</StyledSpan>
      </RatClickTracker>
    </StyledButton>
  );
};
